import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.compliance.checklist.module');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-compliance-checklist-module',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.compliance.checklist.module/view.scss */
/* src/app/portal.lpsysadmin.compliance.checklist.module/view.scss: no such file or directory */`],
})
export class PortalLpsysadminComplianceChecklistModuleComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public loading: boolean = true;
    public saving: boolean = false;
    public templates: any[] = [];
    public activeType: string = 'pre_committee';
    public form: any = this.emptyForm('pre_committee');
    public typeOptions: any[] = [
        { key: 'pre_committee', label: '예비투자심의위원회' },
        { key: 'compliance', label: '준법감시체크리스트' },
        { key: 'main_committee', label: '본투자심의위원회' },
        { key: 'execution', label: '투자 승인/집행 요청' },
    ];

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.membership(['super_admin'], '/admin/invest/dashboard');
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call('load');
        if (code === 200) {
            this.templates = data.rows || [];
            const first = this.filteredTemplates()[0] || this.templates[0];
            this.form = first ? this.clone(first) : this.emptyForm(this.activeType);
        }
        this.loading = false;
        await this.service.render();
    }

    public filteredTemplates(): any[] {
        return (this.templates || []).filter((row: any) => row.template_type === this.activeType);
    }

    public setType(type: string) {
        this.activeType = type;
        const first = this.filteredTemplates()[0];
        this.form = first ? this.clone(first) : this.emptyForm(type);
        this.service.render();
    }

    public clone(row: any): any {
        return JSON.parse(JSON.stringify(row || {}));
    }

    public emptyForm(type: string): any {
        return {
            id: '',
            template_type: type,
            name: '',
            description: '',
            message: '',
            is_active: false,
            documents: [],
            items: [],
            questions: []
        };
    }

    public selectTemplate(row: any) {
        this.form = this.clone(row);
        this.service.render();
    }

    public newTemplate() {
        this.form = this.emptyForm(this.activeType);
        this.service.render();
    }

    public addDocument() {
        const index = (this.form.documents || []).length + 1;
        this.form.documents.push({ key: `doc_${index}`, label: '', required: true });
        this.service.render();
    }

    public removeDocument(index: number) {
        this.form.documents.splice(index, 1);
        this.service.render();
    }

    public addItem() {
        const index = (this.form.items || []).length + 1;
        this.form.items.push({ id: `item_${index}`, label: '', required: true });
        this.service.render();
    }

    public removeItem(index: number) {
        this.form.items.splice(index, 1);
        this.service.render();
    }

    public addQuestion() {
        const index = (this.form.questions || []).length + 1;
        this.form.questions.push({ id: `q_${index}`, question: '', required: true });
        this.service.render();
    }

    public removeQuestion(index: number) {
        this.form.questions.splice(index, 1);
        this.service.render();
    }

    public async save() {
        if (!String(this.form.name || '').trim()) {
            this.service.alert.error('양식명을 입력하세요.');
            return;
        }
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('save', { data: JSON.stringify(this.form) });
        this.saving = false;
        if (code === 200) {
            const row = data.row;
            const index = this.templates.findIndex((item: any) => item.id === row.id);
            if (index >= 0) this.templates[index] = row;
            else this.templates.unshift(row);
            if (row.is_active) {
                for (const item of this.templates) {
                    if (item.template_type === row.template_type && item.id !== row.id) item.is_active = false;
                }
            }
            this.form = this.clone(row);
            this.service.alert.success('저장되었습니다.');
        } else {
            this.service.alert.error(data?.message || '저장에 실패했습니다.');
        }
        await this.service.render();
    }

    public async activate(row: any) {
        const { code, data } = await wiz.call('activate', { id: row.id });
        if (code !== 200) {
            this.service.alert.error(data?.message || '활성화에 실패했습니다.');
            return;
        }
        for (const item of this.templates) {
            if (item.template_type === row.template_type) item.is_active = item.id === row.id;
        }
        this.form = this.clone({ ...row, is_active: true });
        this.service.alert.success('활성 양식으로 설정했습니다.');
        await this.service.render();
    }

    public async remove(row: any) {
        const confirmed = await this.service.alert.show({
            title: '양식 삭제',
            message: '선택한 양식을 삭제하시겠습니까?',
            cancel: '취소',
            action: '삭제',
            actionBtn: 'danger',
            status: 'warning'
        });
        if (!confirmed) return;
        const { code, data } = await wiz.call('remove', { id: row.id });
        if (code !== 200) {
            this.service.alert.error(data?.message || '삭제에 실패했습니다.');
            return;
        }
        this.templates = this.templates.filter((item: any) => item.id !== row.id);
        this.newTemplate();
        this.service.alert.success('삭제되었습니다.');
    }

    public typeLabel(type: string): string {
        const found = this.typeOptions.find((item: any) => item.key === type);
        return found ? found.label : type;
    }
}

export default PortalLpsysadminComplianceChecklistModuleComponent;